(function () {
    'use strict';

    angular.module('app').directive('richTextEditor', RichTextEditorDirectiveFactory);

    RichTextEditorDirectiveFactory.$inject = ['$locale',];
    function RichTextEditorDirectiveFactory($locale) {
        return {
            require: { ngModelCtrl: '^ngModel', ngFormCtrl: '^form' },
            scope: {
                name: '@',
                fullScreenAllowed: '=',
                insertHabilLinkAllowed: '=',
            },
            template: `
                <div ng-attr-id="div_{{name}}">
                    <textarea></textarea>
                </div>`,
            link: function (scope, element, _attrs, controllers) {
                const customOptions = new habilCommon.SunEditorCustomOptions($locale.id, scope.fullScreenAllowed, scope.insertHabilLinkAllowed);
                const editor = new habilCommon.SunEditorWrapper($(element).children()[0], onChange, customOptions);
                const ngModelCtrl = controllers.ngModelCtrl;
                const defaultNode = '<div><br></div>';

                function onChange(editorContent) {
                    scope.$evalAsync(function () {
                        if (editorContent === defaultNode) {
                            ngModelCtrl.$setViewValue(null);
                        }
                        else {
                            ngModelCtrl.$setViewValue(editorContent);
                        }
                    });
                };

                // External changes
                ngModelCtrl.$render = () => {
                    editor.updateContents(ngModelCtrl.$viewValue || '');
                };

                // Cleanup
                scope.$on('$destroy', () => {
                    editor?.destroy();
                });
            }
        };
    }
})();